import React from "react";

import { Caption, Flex } from "@olist/design-system";

import { MarkdownContainer, Message } from "./styles";
import { TypingMarkdown } from "./typing-component";
import { AiIcon } from "icons";

interface MessageProps {
  id: string;
  content: string;
  sender: "user" | "agent";
  timestamp: Date;
}

export function ChatHistory({
  // isAlreadyRender,
  messages,
  theme,
}: {
  messages: MessageProps[];
  // isLoading?: boolean;
  theme?: "light" | "dark";
  // isAlreadyRender?: boolean;
}) {
  if (messages.length === 0) return null;

  return (
    <>
      {messages.map(({ content, id, sender, timestamp }) => (
        <Flex key={id} flexDirection="column" gap="stack.small" id="messages">
          <Flex
            flexDirection="column"
            gap="inline.1xsmall"
            alignItems={sender === "agent" ? "flex-start" : "flex-end"}
          >
            <Flex gap="inline.1xsmall" alignItems="flex-start">
              <Caption bold>
                {sender === "agent" ? "Assistente Virtual" : "Você"}
              </Caption>
              <Caption color="neutral.base">
                {timestamp.toLocaleTimeString("pt-br", { timeStyle: "short" })}
              </Caption>
            </Flex>
            <Flex
              gap="inline.small"
              justifyContent={sender === "user" ? "flex-end" : "flex-start"}
              alignItems="flex-start"
            >
              {sender === "agent" ? (
                <>
                  <Flex
                    justifyContent="center"
                    alignItems="center"
                    backgroundColor="primary.softer"
                    padding="inset.1xsmall"
                    borderRadius="circle"
                  >
                    <AiIcon />
                  </Flex>
                  <MarkdownContainer>
                    <TypingMarkdown
                      text={content}
                      theme={theme}
                      // isLast={messages.length - 1 === index}
                      // isAlreadyRender={isAlreadyRender}
                    />
                  </MarkdownContainer>
                </>
              ) : (
                <Message sender={sender}>{content}</Message>
              )}
            </Flex>
          </Flex>
        </Flex>
      ))}
    </>
  );
}
